import { createFileRoute } from '@tanstack/react-router'

import { GroupForm } from '@/components/retail/group-form'
import { useAuth } from '@/hooks/use-auth'
import { useShopGroup } from '@/hooks/use-shop-catalog-query'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/retail/groups/$groupId',
)({
    component: EditGroupPage,
})

function EditGroupPage() {
    const { groupId } = Route.useParams()
    const { hasPermission } = useAuth()
    const query = useShopGroup(groupId)
    if (query.isLoading) {
        return (
            <p className="page-pad text-muted-foreground">
                {m.common_loading()}
            </p>
        )
    }
    const group = query.data?.data
    if (!group) {
        return (
            <p className="page-pad text-destructive">
                {m.error_shop_group_not_found()}
            </p>
        )
    }
    // key: form làm mới khi đổi sang nhóm khác.
    return (
        <GroupForm
            key={group.id}
            group={group}
            canWrite={hasPermission('shop_catalog.write')}
        />
    )
}
